// extracted by mini-css-extract-plugin
export default {"valueContainer":"OperatorCommissionSelector_valueContainer__4rBdZ","inputPercentage":"OperatorCommissionSelector_inputPercentage__h1lFF"};